@use "@fukuri-admins/ui/layout" as *;

// ui/common の PageHeader（variant='title'）と同じ見た目のバーを自前で組んでいる。
// PageHeader はアクションを差し込むスロットを持たないため、そのまま使うと
// ログアウトボタンを絶対配置で重ねることになり、PageHeader 側の padding に
// 依存した不可視の結合が生まれる。タイトルとボタンを flex の兄弟として
// 並べられるよう、バーの見た目（白背景・下線・padding）をここで再現している。
//
// flex の指定（display / direction / justify-content / align-items）は Stack が持つ。
// ここはバーの見た目だけを持つ。
.StressAssessmentHeader {
  padding: spacing('20') spacing('24');
  border-bottom: 1px solid border('Tertiary');
  background: background('Primary');
}

// PageHeader__Title と同じ指定（20px / 500 / letter-spacing 0.04em）。
// typography トークンの Jp/20_W6 は font-weight 600・letter-spacing 0.02em で
// PageHeader と一致しないため、既存の見た目を保つ目的でトークンを使わず揃えている。
.Title {
  font-size: 20px;
  font-weight: 500;
  color: text('High');
  letter-spacing: 0.04em;
  line-height: 1.5;
}
